import { __get_from_local_storage } from './functions';

let __global_update_icon = async function (play_pause_button, video) {
    if (video[0].paused) {
        play_pause_button[0].classList.remove('play');
        play_pause_button[0].classList.add('pause');
        play_pause_button[0].innerHTML =
            '<i class="stmnt-icons-vdwgb-video-play play self-center flex items-center"></i>';
    } else {
        play_pause_button[0].classList.remove('pause');
        play_pause_button[0].classList.add('play');
        play_pause_button[0].innerHTML =
            '<i class="stmnt-icons-vdwgb-video-pause play self-center flex items-center"></i>';
    }
};

const initAutoplay = (el) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const isPaused = el.paused
            if (!entry.isIntersecting && !isPaused) {
                el.pause()
            } else if (entry.isIntersecting && isPaused) {
                el.play()
            }
        })
    }, {
        threshold: 0
    })
    observer.observe(el)
}

export let __init_video_player = async function () {
    for (let video_container of $('.video--container')) {
        if ($(video_container).length > 0) {
            let video,
                video_button,
                play_pause_button,
                stop_button,
                slider,
                loop_button,
                full_screen_button,
                watch_progress_bar,
                volume_range,
                volume_on,
                volume_off,
                timer_full,
                video_close,
                timer_current;
            video = $(video_container).find('.video--player');
            video_button = $(video_container).parentsUntil('.stmnt--widget').parent().find('.js--video--button');
            play_pause_button = $(video_container).find('.video--play-pause-button');
            stop_button = $(video_container).find('.video--stop');
            // slider = $(video_container).find('.slider');
            loop_button = $(video_container).find('.video--loop');
            video_close = $(video_container).find('.video--close');
            full_screen_button = $(video_container).find('.video--fullscreen');
            timer_full = $(video_container).find('.timer-length');
            timer_current = $(video_container).find('.timer-current');
            // watch_progress_bar = $(video_container).find('.js--video-watch-progress-bar');
            volume_range = $(video_container).find('.js--video-volume-range');
            volume_on = $(video_container).find('.volume--on');
            volume_off = $(video_container).find('.volume--off');

            function __update_icon() {
                if (video[0].paused) {
                    play_pause_button[0].classList.remove('play');
                    play_pause_button[0].classList.add('pause');
                    play_pause_button[0].innerHTML =
                        '<i class="stmnt-icons-vdwgb-video-play play self-center flex items-center"></i>';
                } else {
                    play_pause_button[0].classList.remove('pause');
                    play_pause_button[0].classList.add('play');
                    play_pause_button[0].innerHTML =
                        '<i class="stmnt-icons-vdwgb-video-pause play self-center flex items-center"></i>';
                }
            }

            function __change_video_volume(event) {
                // Prevent default event
                event.preventDefault();

                let value = this.value;

                let progress_bar = this.nextElementSibling;

                progress_bar.style.width = parseFloat(value) + '%';
                video[0].volume = parseFloat(value) / 100;
            }
            function __toggle_video_status() {
                if (video[0].paused) {
                    video[0].play();
                } else {
                    video[0].pause();
                }
            }
            function __stop_video() {
                video[0].currentTime = 0;
                __set_slider_and_timer();
                video[0].pause();
            }

            function __set_slider_and_timer() {
                // get minutes
                let minutes = Math.floor(video[0].currentTime / 60);
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                // get seconds
                let seconds = Math.floor(video[0].currentTime % 60);
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                timer_current[0].textContent = `${minutes}:${seconds}`;
                // slider[0].value = (video[0].currentTime / video[0].duration) * 100;
                if (video[0].currentTime == video[0].duration) {
                    // slider[0].value = 0;
                    __stop_video();
                }

                // watch_progress_bar[0].style.width = (video[0].currentTime / video[0].duration) * 100 + '%';
            }
            function __seeked() {
                // video[0].currentTime = (slider[0].value / 100) * video[0].duration;
            }
            function __set_volume_on() {
                $(volume_range).val(100).trigger('click');
            }
            function __set_volume_off() {
                $(volume_range).val(0).trigger('click');
            }
            function __change_loop_status() {
                if (loop_button[0].classList.contains('loop-off')) {
                    loop_button[0].classList.remove('loop-off');
                    loop_button[0].classList.add('loop-on');
                    video[0].loop = true;
                } else {
                    loop_button[0].classList.remove('loop-on');
                    loop_button[0].classList.add('loop-off');
                    video[0].loop = false;
                }
            }
            function __open_fullscreen() {
                // $('body').removeClass('overflow-hidden');
                $('body').css('overflow', 'initial');
                if (video[0].requestFullscreen) {
                    video[0].requestFullscreen();
                } else if (video[0].mozRequestFullScreen) {
                    /* Firefox */
                    video[0].mozRequestFullScreen();
                } else if (video[0].webkitRequestFullscreen) {
                    /* Chrome, Safari & Opera */
                    video[0].webkitRequestFullscreen();
                } else if (video[0].msRequestFullscreen) {
                    /* IE/Edge */
                    video[0].msRequestFullscreen();
                }
            }

            function __close_video_container() {
                $(video_button).trigger('click');
                $(video).addClass('already-played');
                let progress_bar = volume_range[0].nextElementSibling;

                progress_bar.style.width = parseFloat(0) + '%';
                video[0].volume = 0;
                __stop_video();
            }

            // ALL video event listeners
            play_pause_button[0].addEventListener('click', __toggle_video_status);
            video[0].addEventListener('play', __update_icon);
            video[0].addEventListener('play', () => {
                if (video[0].hasAttribute('data-autoplay')) {
                    return
                }

                const v = video[0]
                v.muted = false

                if (parseInt(v.volume) === 0) {
                    v.volume = 1
                    $(volume_range).val(100).trigger('input');
                }
            });
            video[0].addEventListener('pause', __update_icon);
            stop_button[0].addEventListener('click', __stop_video);
            video[0].addEventListener('timeupdate', __set_slider_and_timer);
            // slider[0].addEventListener('input', __seeked);
            loop_button[0].addEventListener('click', __change_loop_status);
            full_screen_button[0].addEventListener('click', __open_fullscreen);
            volume_range[0].addEventListener('input', __change_video_volume);
            volume_on[0].addEventListener('click', __set_volume_on);
            volume_off[0].addEventListener('click', __set_volume_off);
            video_close[0].addEventListener('click', __close_video_container);

            if (video[0].hasAttribute('data-autoplay')) {
                initAutoplay(video[0])
            }
        }
    }
};

export let __set_video_audio_volume = async function () {
    let current_volume = await __get_from_local_storage('volume');

    $('.video--container').each(async function (index, container) {
        let volume_range_slider = $(container).find('.video--volume').find('.js--video-volume-range');
        let volume_range_slider_bar = $(container).find('.video--volume').find('.progress--bar');

        if (volume_range_slider.length > 0) {
            $(volume_range_slider).val(current_volume).trigger('input');
            $(volume_range_slider_bar).css('width', current_volume * 100 + '%');
        }
    });
};

export let __trigger_video_play_stop = async function (settings) {
    let video_trigger_selector = '.js--video--button';

    const _toggleIcons = ($button, $video) => {
        const $play = $button.find('.play')
        const $stop = $button.find('.stop')

        const isPlaying = $video[0].paused === false

        if (isPlaying) {
            $play.removeClass('flex').addClass('hidden')
            $stop.removeClass('hidden').addClass('flex')
        } else {
            $stop.removeClass('flex').addClass('hidden')
            $play.removeClass('hidden').addClass('flex')
        }
    }

    $(video_trigger_selector).each((index, button) => {
        const $button = $(button)
        const $statementWidget = $button.parentsUntil('.stmnt--widget')
        let $widget = $statementWidget.parent();
        const $video = $widget.find('video.video--player');

        $video[0].addEventListener('play', () => {
            _toggleIcons($button, $video)
        })

        $video[0].addEventListener('pause', () => {
            _toggleIcons($button, $video)
        })
    })

    $(video_trigger_selector).on('click', async function () {
        const $button = $(this)
        const statementWidget = $(this).parentsUntil('.stmnt--widget')
        let widget = statementWidget.parent();

        let video = $(widget).find('video.video--player');

        if (video[0].hasAttribute('data-autoplay')) {
            let isPlaying = false
            if (video[0].paused) {
                video[0].play()
                isPlaying = true
            } else {
                video[0].pause()
            }

            return
        }

        $(this).toggleClass('inside');

        let video_controls = $(video).parent().find('.video-controls');
        let play_stop_button = $(video_controls).find('.video--play-pause-button');
        let volume_range = $(video_controls).find('.js--video-volume-range');

        if ($(this).hasClass('inside')) {
            $(video).prop('muted', false);
            $(video).attr('muted', '');
            // Set widget height fixed for video
            $(widget).addClass('height-set');
            $(this).find('i.play').addClass('hidden');
            $(this).find('i.stop').removeClass('hidden');
            $(widget).find('.section--inner').addClass('away');
            $(widget).find('.this-is-background').removeClass('section--background-inner-gradient');
            $(video).parent().find('.video--container-controls').fadeIn();

            // $('body').addClass('overflow-hidden');

            let timer_full = $(video).parent().find('.timer-length');
            // get minutes
            let full_minutes = Math.floor(video[0].duration / 60);
            if (full_minutes < 10) {
                full_minutes = '0' + full_minutes;
            }
            // get seconds
            let full_seconds = Math.floor(video[0].duration % 60);
            if (full_seconds < 10) {
                full_seconds = '0' + full_seconds;
            }
            timer_full[0].textContent = `${full_minutes}:${full_seconds}`;

            video[0].play();
            let current_v = await settings.__get_volume();
            let progress_bar = volume_range[0].nextElementSibling;
            progress_bar.style.width = parseFloat(current_v) * 100 + '%';
            video[0].volume = current_v;
            $(volume_range).trigger('input');
            $(volume_range).val(100).trigger('click');

            __global_update_icon(play_stop_button, video);

            $(this).removeClass('opacity-1');
            $(this).addClass('pointer-events-none');
            $(this).addClass('opacity-0');

            let widget_offset = $(widget).offset();

            $('html, body').stop().animate(
                {
                    scrollTop: widget_offset.top,
                },
                400,
                'swing'
            );
        } else {
            $(video).prop('muted', true);
            $(video).attr('muted', 'muted');
            // Set widget height fixed for video
            $(widget).removeClass('height-set');
            $(this).find('i.stop').addClass('hidden');
            $(this).find('i.play').removeClass('hidden');
            $(widget).find('.section--inner').removeClass('away');
            $(widget).find('.this-is-background').addClass('section--background-inner-gradient');
            $(video).parent().find('.video--container-controls').fadeOut();

            video[0].pause();

            let progress_bar = volume_range[0].nextElementSibling;
            progress_bar.style.width = parseFloat(0) + '%';
            video[0].volume = 0;
            $(volume_range).trigger('input');

            $(this).removeClass('opacity-0');
            $(this).removeClass('pointer-events-none');
            $(this).addClass('opacity-1');

            // $('body').removeClass('overflow-hidden');
        }
    });
};

export let __start_media_video = async function () {
    let media_video_thumbnailselector = '.media--video-thumbnail';

    if ($(media_video_thumbnailselector).length > 0) {
        for (let media_video_thubmnail of $(media_video_thumbnailselector)) {
            $(media_video_thubmnail).on('click', async function () {
                let video = $(this).parent().find('video');
                let video_button = $(this).parent().find('.media--video-button');
                let figcaption = $(this).parent().parent().find('figcaption');

                if ($(video).length > 0) {
                    video[0].addEventListener('play', () => {
                        const v = video[0]
                        v.muted = false

                        if (parseInt(v.volume) === 0) {
                            v.volume = 1
                        }
                    })
                    $(this).css('display', 'none');
                    $(video_button).css('display', 'none');
                    $(figcaption).css('display', 'none');
                    video[0].play();
                }
            });
        }
    }
};
